module.exports = __webpack_public_path__ + "static/media/card-blog8.730f850d.jpg";